import 'css-chunksrc/client/pages/projectPage/synthesisPage/pdfExport/form/toggleInput/styles.scss';export default {
  "toggleInput": "_toggleInput_cfg6r_1",
  "toggled": "_toggled_cfg6r_22"
};